import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'mip-confirm-modal',
  templateUrl: './mip-confirm-modal.component.html',
  styleUrls: ['./mip-confirm-modal.component.scss'],
})
export class MipConfirmModalComponent implements OnInit {
  @Input() isOpened = false
  @Input() disableCancelAction = false
  @Input() cancelActionLabel: string =
    'collab.component.confirm-modal.action.cancel'

  @Input() disableConfirmAction = false
  @Input() confirmActionLabel: string =
    'collab.component.confirm-modal.action.confirm'

  @Input() busy = false

  @Output() onOpen = new EventEmitter()
  @Output() onClose = new EventEmitter()
  @Output() onCancel = new EventEmitter()
  @Output() onConfirm = new EventEmitter()

  title = null
  message = null

  ngOnInit() {
    console.log(
      'mip-confirm-modal.component->ngOnInit() this.confirmActionLabel',
      this.confirmActionLabel
    )
  }

  open(
    settings: {
      title?
      message?
      cancelActionLabel?
      confirmActionLabel?
    } = {}
  ) {
    this.isOpened = true
    this.onOpen.emit()

    if (settings.title) {
      this.title = settings.title
    }

    if (settings.message) {
      this.message = settings.message
    }

    if (settings.cancelActionLabel) {
      this.cancelActionLabel = settings.cancelActionLabel
    }

    if (settings.confirmActionLabel) {
      this.confirmActionLabel = settings.confirmActionLabel
    }

    return this
  }

  close() {
    this.isOpened = false
    this.onClose.emit()
  }

  cancel() {
    this.close()
    this.onCancel.emit()
  }

  confirm() {
    // this.close();
    this.onConfirm.emit()
  }
}
